import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import * as actions from '../../../../actions/product.actions';
import * as home from '../../../../actions/process.home.actions';

import randomstring from 'uuid/v4';

import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import Card from './Card';
import Machine from './Machine';
import Elaboration from './Elaboration';
import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';

import { AddIcon, BlueTickIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_style.css';

function toolbar(handleSummit) {
    return (
        <BlueTickIcon
            key="submmit-post-product"
            className="hand"
            color="primary"
            onClick={handleSummit}
        />
    );
}

class Product extends React.Component {
    state = {
        id: randomstring(),
        idCliente: undefined,
        nombre: '',
        codigoExterno: '',
        datospreparacion: [],
        datosproduccion: [],
        familiaproducto: [],
        producir: true,
        preparar: true,
        tiempovida: undefined,
        idUnidadesmedida: undefined,
        idEstacion: undefined,
        incluirDesperdicio: undefined,
        unidadesbasicasproduccion: undefined,
        foto: undefined,
        avisocaducidad: '',
        tiempoproyeccion: undefined,
        tramosproyeccion: undefined,
        _families: [],
        _units: [],
        _workStations: [],
        _machinetypes: [],
        error: '',
    };

    constructor(props) {
        super(props);
        props.loadProduct(props.id);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.product) {
            const {
                id,
                nombre,
                foto,
                codigoExterno,
                idCliente,
                producir,
                preparar,
                tiempovida,
                idUnidadesmedida,
                idEstacion,
                unidadesbasicasproduccion,
                avisocaducidad,
                tiempoproyeccion,
                tramosproyeccion,
                familiaproducto,
                datospreparacion,
                datosproduccion,
                incluirDesperdicio,
                _families,
                _units,
                _workStations,
                _machinetypes,
            } = nextProps.product;
            this.setState({
                id: id ? id : randomstring(),
                nombre: nombre ? nombre : '',
                foto: foto ? foto : '',
                idCliente: idCliente ? idCliente : undefined,
                producir: producir ? producir : true,
                preparar: preparar ? preparar : true,
                tiempovida: tiempovida ? tiempovida : '',
                idUnidadesmedida: idUnidadesmedida ? idUnidadesmedida : undefined,
                idEstacion: idEstacion ? idEstacion : undefined,
                unidadesbasicasproduccion: unidadesbasicasproduccion
                    ? unidadesbasicasproduccion
                    : '',
                avisocaducidad: avisocaducidad ? avisocaducidad : '',
                tiempoproyeccion: tiempoproyeccion ? tiempoproyeccion : '',
                tramosproyeccion: tramosproyeccion ? tramosproyeccion : '',
                codigoExterno: codigoExterno ? codigoExterno : '',
                familiaproducto: familiaproducto ? familiaproducto : [],
                datospreparacion: datospreparacion ? datospreparacion : [],
                datosproduccion: datosproduccion ? datosproduccion : [],
                incluirDesperdicio: incluirDesperdicio ? incluirDesperdicio : false,
                _families: _families ? _families : [],
                _units: _units ? _units : [],
                _workStations: _workStations ? _workStations : [],
                _machinetypes: _machinetypes ? _machinetypes : [],
            });
        }
    }

    handleSummit = () => {
        const {
            id,
            nombre,
            foto,
            producir,
            preparar,
            tiempovida,
            idUnidadesmedida,
            idEstacion,
            unidadesbasicasproduccion,
            avisocaducidad,
            tiempoproyeccion,
            tramosproyeccion,
            familiaproducto,
            codigoExterno,
            datospreparacion,
            datosproduccion,
            incluirDesperdicio,
        } = this.state;
        const product = {
            nombre: nombre,
            foto: foto,
            producir: producir,
            preparar: preparar,
            tiempovida: tiempovida,
            idUnidadesmedida: idUnidadesmedida,
            idEstacion: idEstacion,
            unidadesbasicasproduccion: unidadesbasicasproduccion
                ? unidadesbasicasproduccion
                : undefined,
            avisocaducidad: avisocaducidad,
            tiempoproyeccion: tiempoproyeccion,
            tramosproyeccion: tramosproyeccion,
            incluirDesperdicio: incluirDesperdicio ? incluirDesperdicio : false,
            codigoExterno: codigoExterno ? codigoExterno : [],
            familiaproducto: familiaproducto ? familiaproducto : [],
            datospreparacion: datospreparacion ? datospreparacion : [],
            datosproduccion: datosproduccion ? datosproduccion : [],
        };
        if (!this.props.id) {
            this.props
                .addProduct(product)
                .then((r) => {
                    this.props.history.push('/xef/products');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message });
                });
        } else {
            product.id = id;
            this.props
                .editProduct(product)
                .then((r) => {
                    this.props.history.push('/xef/products');
                })
                .catch((error) => {
                    console.error(error);
                    this.setState({ error: error.message });
                });
        }
    };

    CheckCorrect = (state) => {
        if (this.isCorrect(state) && state.pending_changes) {
            const tools = [toolbar(this.handleSummit)];
            this.props.setTools(tools);
        } else {
            this.props.setTools([]);
        }
    };

    handleAddMachine = (event) => {
        const { datosproduccion } = this.state;
        const maquinas = [...datosproduccion];
        maquinas.push({
            idTipomaquina: '',
            minimo: '',
            maximo: '',
            prioritaria: false,
            rangos: [],
        });

        this.setState({ datosproduccion: maquinas });
    };

    handleChange = (name, value) => {
        this.setState({ [name]: value, pending_changes: true });
    };

    handleChangeDatosproduccion = (name, value, index) => {
        const { datosproduccion } = this.state;
        if (datosproduccion.length > index) {
            datosproduccion[index][name] = value;
            this.setState({ datosproduccion: datosproduccion, pending_changes: true });
        }
    };

    handleDeleteMachine = (index) => {
        const { datosproduccion } = this.state;
        if (datosproduccion.length > index) {
            datosproduccion.splice(index, 1);
            this.setState({ datosproduccion: datosproduccion, pending_changes: true });
        }
    };

    handleAddElaboration = (event) => {
        const { datospreparacion } = this.state;
        console.log(datospreparacion);
        datospreparacion.push({
            desde: '',
            hasta: '',
            preparacion: '',
        });
        this.setState({ datospreparacion: datospreparacion });
    };

    handleChangeDatospreparacion = (name, value, index) => {
        const { datospreparacion } = this.state;
        if (datospreparacion.length > index) {
            datospreparacion[index][name] = value;
            this.setState({ datospreparacion: datospreparacion, pending_changes: true });
        }
    };

    handleDeleteElaboration = (index) => {
        const { datospreparacion } = this.state;
        datospreparacion.splice(index, 1);
        this.setState({ datospreparacion: datospreparacion, pending_changes: true });
    };

    handleClose = () => {
        this.setState({ error: '' });
    };

    isCorrect = (state) => {
        const {
            nombre,
            codigoExterno,
            idUnidadesmedida,
            idEstacion,
            unidadesbasicasproduccion,
            tiempovida,
            avisocaducidad,
            tiempoproyeccion,
            tramosproyeccion,
            datospreparacion,
            datosproduccion,
        } = state;
        const unidades = parseInt(unidadesbasicasproduccion, 10);
        const tiempo = parseInt(tiempovida, 10);
        const aviso = parseInt(avisocaducidad, 10);
        const proyeccion = parseInt(tiempoproyeccion, 10);
        return (
            nombre &&
            codigoExterno &&
            idUnidadesmedida &&
            idEstacion &&
            unidades > 0 &&
            tiempo > 0 &&
            aviso <= tiempo &&
            proyeccion > 0 &&
            tramosproyeccion > 0 &&
            datospreparacion.length > 0 &&
            datosproduccion.length > 0
        );
    };

    render() {
        const { id, error, datosproduccion, datospreparacion, _machinetypes } = this.state;
        const { products_is_loading, products_has_errored, info } = this.props;

        this.CheckCorrect(this.state);

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '59' || f === '67')  &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (products_has_errored.hasErrored) {
            return (
                <Error open type={products_has_errored.hasErrored}  message={products_has_errored.error} handleClose={this.handleBack} />
            );
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {products_is_loading && <Loading open opacity />}
                    {error && (
                        <Snackbar
                            open={true}
                            variant="error"
                            text={error}
                            onClose={this.handleClose}
                        />
                    )}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={5} />
                        </div>
                    </Hidden>
                    <div className={'flex_full_row center'}>
                        <div
                            className={
                                'flex_full overflow_y_scroll height100 padding_borders bg_ice_blue showbar'
                            }
                        >
                            <Card data={this.state} onChange={this.handleChange} />
                            <Elaboration
                                {...this.props}
                                datospreparacion={datospreparacion}
                                onChange={this.handleChangeDatospreparacion}
                                onAdd={this.handleAddElaboration}
                                onDelete={this.handleDeleteElaboration}
                            />

                            {datosproduccion &&
                                datosproduccion.length > 0 &&
                                datosproduccion.map((m, index) => {
                                    return (
                                        <Machine
                                            {...this.props}
                                            key={`datos-produccion-${index}`}
                                            id={id}
                                            info={m}
                                            _machinetypes={_machinetypes}
                                            index={index + 1}
                                            onChange={this.handleChangeDatosproduccion}
                                            onDelete={this.handleDeleteMachine}
                                        />
                                    );
                                })}
                            <div
                                onClick={this.handleAddMachine}
                                className="flex_full_row margin_bottom_5 margin_top_12 padding_borders elements_center align_center barlow_medium_place_holder c_bluish uppercase dottedBox hand"
                            >
                                <span>
                                    <FormattedMessage id="recipe_add_machine" />
                                </span>
                                <AddIcon color="primary" className="icon" />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

Machine.propTypes = {
    product: PropTypes.object.isRequired,
    info: PropTypes.object.isRequired,
    products_has_errored: PropTypes.object.isRequired,
    products_is_loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        products_has_errored: state.products_has_errored,
        products_is_loading: state.products_is_loading,
        product: state.product,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Product));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/recipe/Index.js